module.exports = __webpack_public_path__ + "static/media/wrocaw-4767317_640.0fa150ed.jpg";